import axiosInstance from '../axiosInstance';

import { ILoginPayload, IAuthResponse, ISignUpPayload } from './types';

export const signIn = async (payload: ILoginPayload) => {
  const response = await axiosInstance.post<IAuthResponse>('/login', payload);
  return response.data;
};

export const signUp = async (payload: ISignUpPayload) => {
  const response = await axiosInstance.post<IAuthResponse>('/signup', payload);
  return response.data;
};
